import React, { useEffect, useRef, useState } from 'react';
import useDebounce from 'helpers/useDebounce';
import api from 'services';
import { Chip } from 'material-ui';

function PortsAutoCompleteMulti({ 
    selectValue, 
    customValue = '',
    floatingLabelText = '',
    style = {}, 
    textFieldStyle = {}, 
    floatingLabelStyle = {}, 
    hintText,
    menuStyle = {},
    inputStyle = {},
    field = '',
    handleChangeCustomValue = (v) => {},
    withAreas = false,
    mainRegions = false,
    onlyAreas,
    shouldClearCustomValue = false,
    isInBalticIndex = false,
    disabled = false,
}) {
    const [portValue, setPortValue] = useState('');
    const [ports, setPorts] = useState([]);
    const [selectedPorts, setSelectedPorts] = useState([]);
    const [preventFirstSearch, setPreventFirstSearch] = useState(true);
    const dropdownRef = useRef(null);
    const inputRef = useRef(null);
    const [showDropdown, setShowDropdown] = useState(false);

    const debouncedSearchValue = useDebounce(portValue, 500);

    useEffect(() => {
        setPortValue('');
        setSelectedPorts([]);
    }, [shouldClearCustomValue]);

    useEffect(() => {
        if (preventFirstSearch) return;

        if (!debouncedSearchValue || debouncedSearchValue.length < 2) {
            handleChangeCustomValue({});
            setShowDropdown(false);
            return;
        }

        api
            .findPort({
                name: debouncedSearchValue, withAreas, onlyAreas, mainRegions, isInBalticIndex, 
            })
            .then((result) => {
                setPorts(result.data.data);
                setShowDropdown(true);
            });
    }, [debouncedSearchValue]);

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setShowDropdown(false);
        }
    };

    useEffect(() => {
        setPreventFirstSearch(false);
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        setPortValue(customValue);
    }, [customValue]);

    const choosePort = (selectedValue) => {
        if (!selectedPorts.some(port => port._id === selectedValue._id)) {
            const newSelectedPorts = [...selectedPorts, selectedValue];
            setSelectedPorts(newSelectedPorts);
            selectValue(newSelectedPorts);
        }
        setPortValue('');
        setShowDropdown(false);
        setTimeout(() => {
            inputRef.current.focus();
        }, 0);
    };

    const removePort = (portToRemove) => {
        const newSelectedPorts = selectedPorts.filter(port => port._id !== portToRemove._id);
        setSelectedPorts(newSelectedPorts);
        selectValue(newSelectedPorts);
    };

    const changePortValue = (val) => {
        setPortValue(val);
    };
    
    const inputId = 'ports-autocomplete-input';

    return (
        <div style={style}>
            {floatingLabelText && (
                <label htmlFor={inputId} style={{ ...floatingLabelStyle }}>
                    {floatingLabelText}
                </label>
            )}
            <div style={{
                display: 'flex', 
                alignItems: 'center', 
                border: '1px solid #ccc', 
                padding: '4px', 
                borderRadius: '4px', 
                minHeight: '40px', 
                overflowY: 'auto',
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
            }}
            >
                {selectedPorts.map(port => (
                    <Chip
                        key={port._id}
                        onRequestDelete={() => removePort(port)}
                        style={{ margin: '2px' }}
                        labelStyle={{ fontSize: '13px' }}
                    >
                        {port[field || 'name']}
                    </Chip>
                ))}
                <input
                    id={inputId}
                    ref={inputRef}
                    type="text"
                    value={portValue}
                    onChange={e => changePortValue(e.target.value)}
                    placeholder={hintText || 'Port'}
                    style={{
                        ...textFieldStyle, ...inputStyle, border: 'none', outline: 'none', flex: 1, minWidth: '100px', 
                    }}
                    disabled={disabled}
                />
            </div>
            {showDropdown && ports.length > 0 && (
                <ul 
                    ref={dropdownRef}
                    style={{
                        ...menuStyle, 
                        listStyleType: 'none', 
                        padding: '8px 0',
                        margin: '2px 0 0',
                        maxHeight: '300px', 
                        overflow: 'auto',
                        position: 'absolute',
                        zIndex: 1000,
                        backgroundColor: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
                    }}
                >
                    {ports.map((port, index) => (
                        <li 
                            key={index} 
                            onClick={() => choosePort(port)} 
                            onKeyDown={e => e.key === 'Enter' && choosePort(port)}
                            tabIndex={0}
                            role='option'
                            aria-selected={false}
                            style={{ 
                                cursor: 'pointer', 
                                fontSize: '13px',
                                padding: '8px 16px',
                                lineHeight: '1.5',
                                transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1)',
                                '&:hover': {
                                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                                },
                            }}
                        >
                            {port[field || 'name']}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

export default PortsAutoCompleteMulti;



// WEBPACK FOOTER //
// ./app/components/common/PortsAutoCompleteMulti.jsx